import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { CYCLE, firstDelayAt, PHASE_CANONS } from '../bosses/heraut.cycle';
import { defineEnemy, Motion, Pattern } from '../schema';

/** B01-a — CANON DU HÉRAUT. Partie destructible, montée par paire (±118 u).
 *
 *  C'est un ennemi ORDINAIRE qui se trouve avoir un parent : mêmes collisions,
 *  même télégraphe, même butin, même rendu instancié. Rien de spécifique au
 *  boss n'existe côté moteur, et c'est précisément ce qui rend le système de
 *  parties bon marché.
 *
 *  ── Rôle ──
 *  Le canon fait la GÉOGRAPHIE. Son éventail est statique, ouvert à 108° vers
 *  le bas, indépendant du joueur : il interdit une zone au lieu de poursuivre.
 *  C'est le vocabulaire du Rôdeur, déjà appris pendant le monde 1, réemployé
 *  ici à une autre échelle — et la famille VIOLETTE le dit sans un mot. La
 *  palette est réservée (PLAN.md §4.5) : le joueur sait avant l'impact que ces
 *  balles ne le suivront pas.
 *
 *  ── Pourquoi c'est la partie la plus chère à détruire ──
 *  1 100 PV, contre 1 500 pour un bras mais avec une hurtbox deux fois plus
 *  petite : casser les canons d'abord coûte cher en temps, et ce temps se paie
 *  en salves de bras encaissées. C'est exactement le compromis annoncé par
 *  PLAN.md §6.6 — « casser les canons d'abord donne un combat long mais sûr ».
 *  Le joueur choisit sa difficulté ; il ne la subit pas.
 *
 *  ── Immobilité ──
 *  Le champ `motion` est obligatoire mais IGNORÉ : `motionSystem` repositionne
 *  toute entité qui a un parent sur `parent + offset` puis passe à la suivante.
 *  Lui laisser exécuter une trajectoire propre la ferait dériver du vaisseau sur
 *  lequel elle est boulonnée. On déclare Hover à vitesse nulle pour que la
 *  lecture du fichier ne suggère à personne qu'il se passe autre chose. */
export default defineEnemy({
  id: 'heraut-canon',
  rank: Rank.Heavy,
  hp: 1100,
  visualRadius: 30,
  score: 700,
  // Ignoré : les parties héritent du télégraphe du porteur (spawnParts). On
  // déclare la même valeur que le noyau pour qu'une lecture rapide ne laisse pas
  // croire que le canon deviendrait dangereux avant lui.
  telegraph: 2.2,
  drops: 3,
  motion: { kind: Motion.Hover, speed: 0, amplitude: 0, frequency: 0, holdY: 330 },
  emitter: {
    pattern: Pattern.Fan,
    // `every === CYCLE` n'est pas négociable : une période qui ne serait pas le
    // cycle ferait dériver la phase et finirait par déposer une volée dans la
    // fenêtre de punition, c'est-à-dire supprimer le combat sans supprimer une
    // seule ligne de code.
    every: CYCLE,
    count: 7,
    spreadDeg: 108,
    speed: 380,
    firstDelay: firstDelayAt(PHASE_CANONS),
    family: Fam.EnemyPurple,
  },
});
